
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component({})
export default class Accordion extends Vue {
  @PropSync('data') dataSync: any;
}
